import React, {useEffect, useState} from 'react';
import { Card } from 'primereact/card';
import { ProgressBar } from 'primereact/progressbar';
import "./DashboardM.scss"
import { getDashboardData } from "./Integracion";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";


const MaintenanceDashboard = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const [startDate, setStartDate] = useState(firstDayOfMonth);
    const [endDate, setEndDate] = useState(lastDayOfMonth);

    const [summaryData, setSummaryData] = useState([]);
    const [estadisticas, seteStadisticas] = useState([]);
    const [estatusData, setEstatusData] = useState([]);
    const [vehiculosData, setVehiculosData] = useState([]);
    const [percentage, setPercentage] = useState(null);

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        getDashboardData(startDate, endDate).then(data => {
            setSummaryData(data.summaryData);
            setPercentage(data.percentage);
            seteStadisticas(data.statistics);
            setEstatusData(data.unitByStatus);
            setVehiculosData(data.unitByType);
        })
    }

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN'
        }).format(value);
    };

    const formatNumber = (value) => {
        return new Intl.NumberFormat('es-MX').format(value);
    };

    const getPercentage = (value, total) => {
        return ((value / total) * 100).toFixed(1);
    };

    const formatDate = (inputDate) => {
        const date = new Date(inputDate);

        // Validamos si la fecha es válida
        if (isNaN(date)) return '';

        const day = String(date.getDate()).padStart(2, '0'); // día con 2 dígitos
        const month = String(date.getMonth() + 1).padStart(2, '0'); // mes con 2 dígitos
        const year = date.getFullYear(); // año completo

        return `${day}/${month}/${year}`;
    };

    return (
        <Card className="dashboardM">
            {/* Header */}
            <div className="header-M">
                <div className="dashboardM-filters">
                    <div className="filter-group">
                        <label htmlFor="startDate">Fecha de Inicio:</label>
                        <Calendar
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.value)}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    <div className="filter-group">
                        <label htmlFor="endDate">Fecha de Fin:</label>
                        <Calendar
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.value)}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    <div className="filter-group action-group">
                        <label>Ejecutar:</label>
                        <Button
                            label="Ejecutar filtros"
                            icon="pi pi-search"
                            onClick={getData}
                            className="execute-button"
                        />
                    </div>
                </div>
            </div>

            {/* KPIs principales */}
            <div className="principalM">
                <Card className="card-dash card-cal">
                    <div style={{textAlign: 'center', padding: '8px'}}>
                        <div className="card-data">
                            <i className="pi pi-star-fill" style={{fontSize: '28px'}}></i>
                        </div>
                        <h3 style={{margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600'}}>Calificación
                            Promedio</h3>
                        <div className="card-text">{percentage?.promedio.toFixed(2)}%
                        </div>
                        <ProgressBar
                            value={percentage?.promedio}
                            style={{height: '10px', fontSize: '10px'}}
                        />
                        <div style={{fontSize: '14px', opacity: 0.9, marginTop: '8px'}}>Excelente desempeño</div>
                    </div>
                </Card>

                <Card className="card-dash card-man">
                    <div style={{textAlign: 'center', padding: '8px'}}>
                        <div className="card-data">
                            <i className="pi pi-wrench" style={{fontSize: '28px'}}></i>
                        </div>
                        <h3 style={{margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600'}}>Mantenimientos</h3>
                        <div className="card-text">{formatNumber(summaryData.mantenimientos)}</div>
                        <div style={{fontSize: '14px', opacity: '0.9'}}>Total realizados en el período</div>
                    </div>
                </Card>

                <Card className="card-dash card-inv">
                    <div style={{textAlign: 'center', padding: '8px'}}>
                        <div className="card-data">
                            <i className="pi pi-dollar" style={{fontSize: '28px'}}></i>
                        </div>
                        <h3 style={{margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600'}}>Inversión Total</h3>
                        <div className="card-text">{formatCurrency(summaryData.total)}</div>
                        <div style={{fontSize: '14px', opacity: '0.9'}}>Incluye IVA</div>
                    </div>
                </Card>

                <Card className="card-dash card-fl">
                    <div style={{textAlign: 'center', padding: '8px'}}>
                        <div className="card-data">
                            <i className="pi pi-car" style={{fontSize: '28px'}}></i>
                        </div>
                        <h3 style={{margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600'}}>Flota Total</h3>
                        <div style={{fontSize: '42px', fontWeight: '800', marginBottom: '8px'}}>{percentage?.flota}</div>
                        <div style={{fontSize: '14px', opacity: '0.9'}}>Unidades activas</div>
                    </div>
                </Card>
            </div>

            {/* Desglose de costos */}
            <div className="card-cost">
                <div style={{padding: '30px'}}>
                    <h3 className="h3-cost">
                        <i className="pi pi-money-bill"
                           style={{marginRight: '12px', color: '#059669', fontSize: '24px'}}></i>
                        Desglose Detallado de Costos
                    </h3>

                    <div className="cost">
                        <div className="card-des-cost card-cost-pi">
                            <div style={{position: 'absolute', top: '-10px', right: '-10px', opacity: 0.1}}>
                                <i className="pi pi-cog" style={{fontSize: '80px'}}></i>
                            </div>
                            <div style={{position: 'relative', zIndex: 1}}>
                                <h4 style={{margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600'}}>Costo Piezas</h4>
                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: '800'
                                }}>{formatCurrency(summaryData.costoPiezas)}</div>
                                <div style={{fontSize: '14px', opacity: 0.9, marginTop: '4px'}}>
                                    {getPercentage(summaryData.costoPiezas, summaryData.costoTotal)}% del total
                                </div>
                            </div>
                        </div>

                        <div className="card-des-cost card-cost-ob">
                            <div style={{position: 'absolute', top: '-10px', right: '-10px', opacity: 0.1}}>
                                <i className="pi pi-users" style={{fontSize: '80px'}}></i>
                            </div>
                            <div style={{position: 'relative', zIndex: 1}}>
                                <h4 style={{margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600'}}>Mano de Obra</h4>
                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: '800'
                                }}>{formatCurrency(summaryData.costoManoObra)}</div>
                                <div style={{fontSize: '14px', opacity: 0.9, marginTop: '4px'}}>
                                    {getPercentage(summaryData.costoManoObra, summaryData.costoTotal)}% del total
                                </div>
                            </div>
                        </div>

                        <div className="card-des-cost card-cost-iva">
                            <div style={{position: 'absolute', top: '-10px', right: '-10px', opacity: 0.1}}>
                                <i className="pi pi-percentage" style={{fontSize: '80px'}}></i>
                            </div>
                            <div style={{position: 'relative', zIndex: 1}}>
                                <h4 style={{margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600'}}>IVA</h4>
                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: '800'
                                }}>{formatCurrency(summaryData.iva)}</div>
                                <div style={{fontSize: '14px', opacity: 0.9, marginTop: '4px'}}>
                                    16% sobre subtotal
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Estadísticas de servicio */}
            <div className="card-details">
                <div style={{padding: '30px'}}>
                    <h3 className="h3-details">
                        <i className="pi pi-chart-line"
                           style={{marginRight: '12px', color: '#3b82f6', fontSize: '24px'}}></i>
                        Estadísticas de Servicio
                    </h3>

                    <div className="grid-details">
                        <div style={{border: '2px solid #fecaca', backgroundColor: '#fef2f2'}} className="card-details-title">
                            <div style={{backgroundColor: '#dc2626'}} className="card-details-text">
                                <i className="pi pi-exclamation-triangle" style={{fontSize: '20px'}}></i>
                            </div>
                            <div style={{fontSize: '32px', fontWeight: '800', color: '#dc2626', marginBottom: '4px'}}>
                                {estadisticas.vencidosKM}
                            </div>
                            <div style={{color: '#7f1d1d', fontSize: '14px', fontWeight: '600'}}>Vencidos por KM</div>
                        </div>

                        <div style={{border: '2px solid #fecaca', backgroundColor: '#fef2f2'}} className="card-details-title">
                            <div style={{backgroundColor: '#dc2626'}} className="card-details-text">
                                <i className="pi pi-clock" style={{fontSize: '20px'}}></i>
                            </div>
                            <div style={{fontSize: '32px', fontWeight: '800', color: '#dc2626', marginBottom: '4px'}}>
                                {estadisticas.vencidosFecha}
                            </div>
                            <div style={{color: '#7f1d1d', fontSize: '14px', fontWeight: '600'}}>Vencidos por Fecha
                            </div>
                        </div>

                        <div style={{border: '2px solid #bfdbfe', backgroundColor: '#f0f9ff'}} className="card-details-title">
                            <div style={{backgroundColor: '#0369a1'}} className="card-details-text">
                                <i className="pi pi-file-edit" style={{fontSize: '20px'}}></i>
                            </div>
                            <div style={{fontSize: '32px', fontWeight: '800', color: '#0369a1', marginBottom: '4px'}}>
                                {estadisticas.solicitudes}
                            </div>
                            <div style={{color: '#0c4a6e', fontSize: '14px', fontWeight: '600'}}>Solicitudes</div>
                        </div>

                        <div style={{backgroundColor: '#f0fdf4', border: '2px solid #bbf7d0'}} className="card-details-title">
                            <div style={{backgroundColor: '#166534'}} className="card-details-text">
                                <i className="pi pi-check-circle" style={{fontSize: '20px'}}></i>
                            </div>
                            <div style={{fontSize: '32px', fontWeight: '800', color: '#166534', marginBottom: '4px'}}>
                                {estadisticas.ordenesServicio}
                            </div>
                            <div style={{color: '#14532d', fontSize: '14px', fontWeight: '600'}}>Órdenes de Servicio
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Distribución por estatus */}
            <div className="card-details">
                <div style={{padding: '30px'}}>
                    <h3 className="h3-details">
                        <i className="pi pi-objects-column"
                           style={{marginRight: '12px', color: '#7c3aed', fontSize: '24px'}}></i>
                        Distribución por Estatus
                    </h3>

                    <div className="grid-details">
                        {estatusData.map((item, index) => (
                            <div key={index} style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '16px',
                                backgroundColor: 'white',
                                borderRadius: '10px',
                                border: `2px solid ${item.color}20`,
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                                 onMouseEnter={(e) => {
                                     e.currentTarget.style.transform = 'translateY(-2px)';
                                     e.currentTarget.style.boxShadow = '0 8px 25px -8px rgba(0,0,0,0.2)';
                                 }}
                                 onMouseLeave={(e) => {
                                     e.currentTarget.style.transform = 'translateY(0px)';
                                     e.currentTarget.style.boxShadow = 'none';
                                 }}>
                                <div style={{
                                    backgroundColor: item.color,
                                    color: 'white',
                                    borderRadius: '8px',
                                    width: '40px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '12px'
                                }}>
                                    <i className={item.icon} style={{fontSize: '16px'}}></i>
                                </div>
                                <div style={{flex: 1}}>
                                    <div style={{fontSize: '24px', fontWeight: '800', color: item.color}}>
                                        {item.cantidad}
                                    </div>
                                    <div style={{fontSize: '12px', color: '#64748b', fontWeight: '500'}}>
                                        {item.nombre}
                                    </div>
                                </div>
                                <div style={{
                                    fontSize: '10px',
                                    color: '#94a3b8',
                                    backgroundColor: '#f8fafc',
                                    padding: '4px 8px',
                                    borderRadius: '12px',
                                    fontWeight: '600'
                                }}>
                                    {getPercentage(item.cantidad, percentage?.flota)}%
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Distribución por tipo de vehículo */}
            <div className="card-details">
                <div style={{padding: '30px'}}>
                    <h3 className="h3-details">
                        <i className="pi pi-truck"
                           style={{marginRight: '12px', color: '#dc2626', fontSize: '24px'}}></i>
                        Flota por Tipo de Vehículo
                    </h3>

                    <div className="cost">
                        {vehiculosData.sort((a, b) => b.cantidad - a.cantidad).map((vehiculo, index) => (
                            <div key={index} style={{
                                background: `linear-gradient(135deg, ${vehiculo.color}15 0%, ${vehiculo.color}05 100%)`,
                                border: `2px solid ${vehiculo.color}30`,
                                borderRadius: '12px',
                                padding: '20px',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: '-15px',
                                    right: '-15px',
                                    opacity: 0.1,
                                    color: vehiculo.color
                                }}>
                                    <i className={vehiculo.icon} style={{fontSize: '80px'}}></i>
                                </div>
                                <div style={{position: 'relative', zIndex: 1}}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '12px'
                                    }}>
                                        <div style={{
                                            backgroundColor: vehiculo.color,
                                            color: 'white',
                                            borderRadius: '8px',
                                            width: '36px',
                                            height: '36px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '12px'
                                        }}>
                                            <i className={vehiculo.icon} style={{fontSize: '16px'}}></i>
                                        </div>
                                        <h4 style={{
                                            margin: 0,
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#1e293b'
                                        }}>
                                            {vehiculo.tipo}
                                        </h4>
                                    </div>
                                    <div style={{
                                        fontSize: '32px',
                                        fontWeight: '800',
                                        color: vehiculo.color,
                                        marginBottom: '8px'
                                    }}>
                                        {vehiculo.cantidad}
                                    </div>
                                    <div style={{
                                        fontSize: '14px',
                                        color: '#64748b',
                                        fontWeight: '500'
                                    }}>
                                        {getPercentage(vehiculo.cantidad, percentage?.flota)}% de la flota
                                    </div>
                                    <div style={{
                                        width: '100%',
                                        height: '4px',
                                        backgroundColor: `${vehiculo.color}20`,
                                        borderRadius: '2px',
                                        marginTop: '12px',
                                        overflow: 'hidden'
                                    }}>
                                        <div style={{
                                            width: `${getPercentage(vehiculo.cantidad, percentage?.flota)}%`,
                                            height: '100%',
                                            backgroundColor: vehiculo.color,
                                            borderRadius: '2px'
                                        }}></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="footer-style">
                <div className="footer-style-div">
                    <i className="pi pi-info-circle" style={{marginRight: '8px', color: '#3b82f6'}}></i>
                    <span style={{fontWeight: '600'}}>Dashboard actualizado automáticamente</span>
                </div>
                <p style={{margin: 0}}>
                    Datos correspondientes al período del {formatDate(startDate)} al {formatDate(endDate)}
                </p>
            </div>
        </Card>
    )
}

export default MaintenanceDashboard